export default {
  templateUrl: 'static/frontend/views/search.html',
  controller: 'SearchCtrl',
  controllerAs: 'vm',
  bindings: {},
};
